<template>
  <div class="relative inline-block text-left">
    <div>
      <button
        @click.stop="toggleSelect = !toggleSelect"
        type="button"
        :class="styles.optionButton"
        id="options-menu"
        aria-haspopup="true"
        aria-expanded="true"
      >
        <!--  -->
        <span
          :class="[
            !active_reduction ? 'ml-0' : '-ml-1',
            isOnline ? 'bg-ontick-green-500' : 'bg-ontick-red-500',
          ]"
          class="mr-3 inline-flex items-center rounded-full font-bold leading-snug text-white"
        >
          <div class="text-ontick-first h-3 w-3 rounded-full">&nbsp;</div>
        </span>

        <span class="text-sm text-white"> Status </span>
        <!-- <ontick-text
          v-show="!active_reduction"
          size="small"
          color="green"
          weight="bold"
          >Online</ontick-text
        >
        <ontick-text
          v-show="!active_reduction"
          size="small"
          color="blue-ligth"
          weight="medium"
          class="ml-1"
          >14.19kbps</ontick-text
        > -->
        <!--  -->
      </button>
    </div>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-show="toggleSelect"
        :class="[styles.boxSelect]"
        role="menu"
        aria-orientation="bottom"
        aria-labelledby="options-menu"
        v-click-outside="hide"
      >
        <div class="py-3 px-3">
          <ontick-text
            class="whitespace-no-wrap group inline-flex items-center"
          >
            Renderizando:
            <span class="text-ontick-green-500 px-1 font-bold">Normal</span>
            ({{ fps }} fps)
          </ontick-text>
        </div>
        <div class="py-3 px-3">
          <ontick-text
            class="whitespace-no-wrap group inline-flex items-center"
          >
            Conexão:
            <span v-if="isOnline" class="text-ontick-green-500 px-1 font-bold"
              >Online</span
            >
            <span v-if="!isOnline" class="text-ontick-red-500 px-1 font-bold"
              >Offline</span
            >
            {{ kbps }} Kbps
          </ontick-text>
        </div>
        <!-- <div class="py-3 px-3">
          <ontick-text
            class="whitespace-no-wrap inline-flex items-center group"
          >
            Latencia:
            <span class="text-ontick-green-500 font-bold px-1">Boa</span>
            (35 ms)
          </ontick-text>
        </div> -->
      </div>
    </transition>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import EventBus from "@/app/shared/utils/event_bus";

// var calculatedBitrate = ((data.length / 1000) * 8);

export default {
  name: "application-status",
  directives: {
    ClickOutside,
  },
  data() {
    return {
      isOnline: false,
      kbps: 0,
      fps: 0,
      toggleSelect: false,
      optionDefault: null,
      styles: {
        option:
          "group flex items-center px-3 py-2 text-xs text-white  border-b border-ontick-carbon-500 last:border-ontick-carbon-500",
        boxSelect:
          "left-0 -mt-32 origin-top-right border border-ontick-steel-500 absolute mt-2 rounded-md shadow-md bg-ontick-steel-500 ",
        optionButton:
          "overflow-hidden inline-flex items-center justify-start w-full rounded-md border border-ontick-carbon-500 shadow-sm px-3 py-2   font-medium text-gray-700  focus:outline-none focus:ring-2 ",
      },
    };
  },
  created() {
    EventBus.$on(
      "KBPS",
      (payload) => (this.kbps = parseFloat(payload).toFixed(2))
    );
    EventBus.$on(
      "WEBSOCKET_IS_CONNECTED",
      (payload) => (this.isOnline = payload)
    );
  },
  mounted() {
    // prevent click outside event with popupItem.
    this.popupItem = this.$el;
    this.measureFPS();
  },
  props: {
    active_reduction: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hide() {
      this.toggleSelect = false;
    },
    measureFPS() {
      const vm = this;
      let prevTime = Date.now();
      let frames = 0;
      requestAnimationFrame(function loop() {
        const time = Date.now();
        frames++;
        if (time > prevTime + 1000) {
          vm.fps = Math.round((frames * 1000) / (time - prevTime));
          prevTime = time;
          frames = 0;
        }
        requestAnimationFrame(loop);
      });
    },
  },
};
</script>
